module.exports = __webpack_public_path__ + "70dccba21ea05ba2ccd03192e492f45f.pdf";